import { SOURCE_CODES } from './config';

const userAgent = navigator.userAgent;
const wxwork = /wxwork/i.test(userAgent);
const dingtalk = /dingtalk/i.test(userAgent);
const feishu = /lark/i.test(userAgent);

export const isMobile = /iphone|ipod|ios|android|ipad/i.test(userAgent);

export const appClient = {
  wxwork,
  dingtalk,
  feishu
};

export function getOpenPlats() {
  const sourceCode = localStorage.sourceCode;
  return {
    isFSISV: SOURCE_CODES.feishu === sourceCode,
    isDDISV: SOURCE_CODES.dingtalk === sourceCode,
    isQWISV: SOURCE_CODES.wxwork === sourceCode
  };
}
